import React, { useState, useCallback, useRef, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { useLocation, useNavigate } from "react-router-dom";
import MenuBar from "../MenuBar/MenuBar";
import "./QRscanner.css";
import Axios from "axios";
import { Camera } from "react-camera-pro";
import { HttpGet, HttpPost, HttpPostFile } from "../../providers/HttpClient";
import Alert from "../alertComponent/alertComponent";
import spinner from "../../assets/svg/spinner.svg";
import { toast } from "react-toastify";
import moment from "moment";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "../../assets/marker.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faCrosshairs } from "@fortawesome/free-solid-svg-icons";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png").default,
  iconUrl: require("leaflet/dist/images/marker-icon.png").default,
  shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
});

const SelfieCheckin = () => {
  let location: any = useLocation();
  const navigate = useNavigate();
  const camera = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapContainerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState(false);
  const [image, setImage] = useState(null);
  const [shift, setShift] = useState("");
  const [openCamera, setOpenCamera] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [shiftList, setShiftList] = useState<any>([]);
  const [isGetAddress, setIsGetAddress] = useState(false);
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [openMap, setOpenMap] = useState(false);
  const mapInitialized = useRef(false);

  const myIcon = L.icon({
    iconUrl: markerIcon,
    iconSize: [82, 82],
    iconAnchor: [16, 32],
  });

  const alert = (message, type, subMessage) => {
    setOpen(true);
    setAlertMessage(message);
    setAlertType(type);
  };

  const closeAction = async () => {
    setOpen(false);
    navigate("/home");
  };

  const getShiftList = async () => {
    setLoading(true);
    HttpGet(`member/combo/shift`)
      .then((res: any) => {
        setShiftList(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getAddress = async (
    latitude: number | null,
    longitude: number | null
  ) => {
    if (!latitude || !longitude) {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            setLatitude(lat);
            setLongitude(lng);

            setIsGetAddress(true);
            setOpenMap(true);
          },
          () => {
            toast.error("Lokasi tidak tersedia, aktifkan izin lokasi");
            navigate("/home");
          }
        );
      } else {
        toast.error("Browser tidak mendukung geolocation");
        navigate("/home");
      }
      return;
    }

    setLoading(true);
    setIsGetAddress(true);
    setOpenMap(true);
    setLoading(false);
  };

  const convertBase64ToFile = (base64String) => {
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ia], { type: "image/png" });
    const file = new File([blob], "image.png", { type: "image/png" });

    return file;
  };

  const checkIn = (image) => {
    let file = convertBase64ToFile(image);

    let formData = new FormData();
    formData.append("image", file);
    setLoading(true);
    HttpPostFile(`member/images?feature=checkin`, formData).then((res: any) => {
      let datas = {
        checkInPhoto: res.data,
        location: {
          lat: latitude,
          lon: longitude,
          address: address,
        },
      };
      HttpPost(`member/attendance_by_photo/${shift}`, datas)
        .then((resp: any) => {
          alert("Absensi Berhasil", true, "");
          setLoading(false);
        })
        .catch((err) => {
          alert("Absensi Gagal", false, "");
        });
    });
  };

  const handleLocateUser = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          setLatitude(lat);
          setLongitude(lng);

          if (mapRef.current && markerRef.current) {
            mapRef.current.setView([lat, lng], 19);
            markerRef.current.setLatLng([lat, lng]);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          toast.error("Tidak dapat mengambil lokasi");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      toast.error("Browser tidak mendukung geolocation");
    }
  };

  // Initialize map with Leaflet
  useEffect(() => {
    if (
      openMap &&
      mapContainerRef.current &&
      latitude &&
      longitude &&
      !mapInitialized.current
    ) {
      mapInitialized.current = true;

      // Create map
      mapRef.current = L.map(mapContainerRef.current, {
        center: [latitude, longitude],
        zoom: 19,
        maxZoom: 21,
        minZoom: 2,
        zoomControl: false,
      });

      // Add Google Maps tile layer with traffic
      L.tileLayer(
        "https://{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          minZoom: 2,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      ).addTo(mapRef.current);

      // Add marker
      markerRef.current = L.marker([latitude, longitude], {
        draggable: false,
        icon: myIcon,
      }).addTo(mapRef.current);

      // Create custom locate control
      const locateControl = L.control({ position: "bottomright" });
      locateControl.onAdd = function () {
        const div = L.DomUtil.create("div", "leaflet-bar leaflet-control");

        div.style.backgroundColor = "#fff";
        div.style.width = "34px";
        div.style.height = "34px";
        div.style.cursor = "pointer";
        div.style.display = "flex";
        div.style.alignItems = "center";
        div.style.justifyContent = "center";
        div.style.marginBottom = "50px";
        div.style.borderRadius = "4px";
        div.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";

        const root = ReactDOM.createRoot(div);
        root.render(
          <div
            onClick={handleLocateUser}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
            }}
            title="Pusatkan ke Lokasi Saya"
          >
            <FontAwesomeIcon icon={faCrosshairs} fontSize={18} />
          </div>
        );

        return div;
      };
      locateControl.addTo(mapRef.current);

      // Show popup if using default location
      if (latitude === -6.2088 && longitude === 106.8456) {
        L.popup()
          .setLatLng([latitude, longitude])
          .setContent("Geolocation failed. Defaulting to Jakarta.")
          .openOn(mapRef.current);
      }
    }

    // Cleanup
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
        mapInitialized.current = false;
      }
    };
  }, [openMap, latitude, longitude]);

  // Get initial location and shift list
  useEffect(() => {
    getShiftList();
  }, []);

  return (
    <>
      <div className="bg-main h-5/6 mb-12">
        <Alert
          type={alertType}
          isOpen={open}
          closeAction={closeAction}
          message={alertMessage}
          subMessage={""}
        />
        {openCamera || openMap ? null : (
          <div className="px-5 py-24 mb-8">
            <label htmlFor="location" className="block text-gray-700">
              Pilihan Shift
            </label>
            <select
              value={shift}
              onChange={(event) => {
                setShift(event.target.value);
                getAddress(latitude, longitude);
              }}
              className="bg-white border border-gray-300 rounded-full px-4 py-2 w-full"
            >
              <option disabled value={""}></option>
              {shiftList.map((el: any, index: any) => (
                <option key={index} value={el._id}>
                  {el.name +
                    " (" +
                    moment(el.checkInTime).format("HH:mm") +
                    " - " +
                    moment(el.checkOutTime).format("HH:mm") +
                    ")"}
                </option>
              ))}
            </select>
          </div>
        )}
        {openMap && !openCamera ? (
          <div className="">
            <div
              ref={mapContainerRef}
              id="map"
              style={{ height: "90vh", width: "100%", paddingBottom: "80px" }}
            ></div>
          </div>
        ) : null}
        {openCamera && openMap ? (
          <>
            <div className="camera-container">
              <div className="camera-video">
                <Camera
                  facingMode="user"
                  aspectRatio={"cover"}
                  ref={camera}
                  errorMessages={{
                    noCameraAccessible: "no camera",
                    permissionDenied: "denied",
                    switchCamera: "switch",
                    canvas: "aaa",
                  }}
                />
              </div>
            </div>
          </>
        ) : null}
      </div>
      <div className="fixed bottom-0 w-full bg-white px-4 py-5 z-[9999]">
        {!shift ? (
          <button
            className={
              "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-100 px-5 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 w-full"
            }
          >
            {"Lanjutkan"}
          </button>
        ) : (
          <button
            disabled={isLoading}
            onClick={() => {
              !openCamera && openMap
                ? setOpenCamera(true)
                : checkIn(camera.current.takePhoto());
            }}
            className={
              isLoading
                ? "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-200 px-5 py-2 text-sm font-medium  w-full"
                : "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-300 px-5 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 w-full"
            }
          >
            <div className="flex items-center justify-center">
              <img
                hidden={!isLoading}
                src={spinner}
                alt=""
                className="animate-spin h-5 w-5 mr-3 "
              />
              {!openCamera && openMap
                ? "Lanjutkan"
                : openCamera && !openMap
                ? "Ambil Gambar"
                : "Lanjutkan"}
            </div>
          </button>
        )}
      </div>
    </>
  );
};
export default SelfieCheckin;
